import { render } from "./PersonFacesGrid.vue?vue&type=template&id=16d0b7ca&scoped=true&ts=true"
import script from "./PersonFacesGrid.vue?vue&type=script&lang=ts"
export * from "./PersonFacesGrid.vue?vue&type=script&lang=ts"

import "./PersonFacesGrid.vue?vue&type=style&index=0&id=16d0b7ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d0b7ca"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress});
